const CLIENT_ID_KEY = 'flashroom_id';
const LOCAL_ACCOUNT_ID_KEY = 'local_account_id';
const LEGACY_ORIGINAL_CLIENT_ID_KEY = 'flashroom_original_client_id';

function isAccountClientId(clientId: string | null) {
    return !!clientId?.trim().startsWith('account:');
}

function getValidLocalClientId(clientId: string | null) {
    const trimmed = clientId?.trim();
    return trimmed && !isAccountClientId(trimmed) ? trimmed : null;
}

export function getOrCreateLocalAccountId() {
    let localAccountId = getValidLocalClientId(
        localStorage.getItem(LOCAL_ACCOUNT_ID_KEY)
    );

    if (localAccountId) {
        return localAccountId;
    }

    if (isAccountClientId(localStorage.getItem(LOCAL_ACCOUNT_ID_KEY))) {
        localStorage.removeItem(LOCAL_ACCOUNT_ID_KEY);
    }

    localAccountId =
        getValidLocalClientId(
            localStorage.getItem(LEGACY_ORIGINAL_CLIENT_ID_KEY)
        ) ||
        getValidLocalClientId(localStorage.getItem(CLIENT_ID_KEY)) ||
        crypto.randomUUID();

    localStorage.setItem(LOCAL_ACCOUNT_ID_KEY, localAccountId);

    if (!localStorage.getItem(CLIENT_ID_KEY)) {
        localStorage.setItem(CLIENT_ID_KEY, localAccountId);
    }

    return localAccountId;
}

export function restoreLocalAccountId() {
    const localAccountId = getOrCreateLocalAccountId();
    localStorage.setItem(CLIENT_ID_KEY, localAccountId);
    return localAccountId;
}

export function getOrCreateClientId() {
    let clientId = localStorage.getItem(CLIENT_ID_KEY);

    if (!clientId) {
        clientId = getOrCreateLocalAccountId();
        localStorage.setItem(CLIENT_ID_KEY, clientId);
    } else {
        getOrCreateLocalAccountId();
    }

    return clientId;
}

export function retireClaimedClientId(claimedClientId: string, accountClientId?: string) {
    const claimed = claimedClientId.trim();
    if (!claimed) return;

    for (const key of [CLIENT_ID_KEY, LOCAL_ACCOUNT_ID_KEY, LEGACY_ORIGINAL_CLIENT_ID_KEY]) {
        if (localStorage.getItem(key) === claimed) {
            localStorage.removeItem(key);
        }
    }

    if (accountClientId?.trim()) {
        localStorage.setItem(CLIENT_ID_KEY, accountClientId.trim());
    }
}
